import { atom } from 'jotai/index';

export const historyPatientSearchTextAtom = atom('');
